function FallbackImage({ src, alt, className, style, onClick }) {
    const handleError = (e) => {
        e.target.onerror = null;
        e.target.src = '/placeholder.png';
    };

    return (
        <img
            src={src}
            alt={alt || ''}
            className={className}
            style={style}
            onClick={onClick}
            onError={handleError}
        />
    );
}

export default FallbackImage;